import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
// react component used to create charts
import ChartistGraph from 'react-chartist';
import { DataAPI } from 'services/DataService.jsx';
import Card from 'components/Card/Card.jsx';
// import StatsCard from 'components/Card/StatsCard.jsx';
// import Tasks from 'components/Tasks/Tasks.jsx';

import { style } from "variables/Variables.jsx";
import NotificationSystem from 'react-notification-system';
import { Authenticator } from 'services/AuthService.jsx';
import TimeAgo from 'react-timeago';
import moment from 'moment';

// import {
//     dataPie,
//     dataSales,
//     optionsSales,
//     responsiveSales,
//     dataBar,
//     optionsBar,
//     responsiveBar,
//     table_data
// } from 'variables/Variables.jsx';
// import * as Ps from "perfect-scrollbar";

import Log from 'services/Log.jsx'



let Chartist = require('chartist');
let ChartistTooltip = require('chartist-plugin-tooltips');
Log.debug(ChartistTooltip);

// function ctPointLabels(options) {
//   return function ctPointLabels(chart) {
//     var defaultOptions = {
//       labelClass: 'ct-label',
//       labelOffset: {
//         x: 0,
//         y: -10
//       },
//       textAnchor: 'middle'
//     };
//
//     options = Chartist.extend({}, defaultOptions, options);
//
//     if(chart instanceof Chartist.Line) {
//       chart.on('draw', function(data) {
//         if(data.type === 'point') {
//           data.group.elem('text', {
//             x: data.x + options.labelOffset.x,
//             y: data.y + options.labelOffset.y,
//             style: 'text-anchor: ' + options.textAnchor
//           }, options.labelClass).text(data.series[data.index]);
//         }
//       });
//     }
//   }
// }

class Dashboard extends Component {

  constructor(props){
      super(props);
      Log.debug("[Chartist]", Chartist);
      this.state = {
        selected_project : {
          owner: {},
          plan: {}
        },
        usageData: {},
        maClients: {},
        maDatapoints: {},
        usageTimestamp: new Date(),
        maClientsTimestamp: new Date(),
        maDatapointsTimestamp: new Date(),
        tooltipOptions: {
          onlyInteger: true,
          low: 0,
          axisX: {
            labelInterpolationFnc: function(value, index) {
              return index % 5 === 0 ? value : '';
            }
          },
          plugins: [
            Chartist.plugins.tooltip({
              anchorToPoint: false,
              appendToBody: false,
              tooltipOffset: {
                x: 30,
                y: 60
              }
            })
          ]
        },
        tooltipOptionsSimple: {
          onlyInteger: true,
          plugins: [
            Chartist.plugins.tooltip({
              anchorToPoint: false,
              appendToBody: false,
              tooltipOffset: {
                x: 30,
                y: 60
              }
            })
          ]
        }
      }
  }

  componentDidMount(props) {
    const self = this;
    Authenticator.getUser((user) => {
      Log.debug(user.selectedProject);
      if (user.selectedProject) {
        DataAPI.getMonthlyActiveClients(response => {
          Log.debug(response);
          if (response.data.success) {
            DataAPI.getMonthlyUsage(usage => {
              if (usage.data.success) {
                self.setState({selected_project: user.selectedProject, usageTimestamp: user.timestamp, usageData: self.getUsageData(user.selectedProject), maClientsTimestamp: moment(response.timestamp, 'MM/DD/YYYY HH:mm:ss').toDate(), maClients: self.getMAClients(response.data.data), maDatapointsTimestamp: moment(usage.timestamp, 'MM/DD/YYYY HH:mm:ss').toDate(), maDatapoints: self.getMADatapoints(usage.data.data)});
              } else {
                self.setState({selected_project: user.selectedProject, usageTimestamp: user.timestamp, usageData: self.getUsageData(user.selectedProject), maClientsTimestamp: moment(response.timestamp, 'MM/DD/YYYY HH:mm:ss').toDate(), maClients: self.getMAClients(response.data.data)});
              }
            });
          } else {
            self.setState({selected_project: user.selectedProject, usageTimestamp: user.timestamp, usageData: self.getUsageData(user.selectedProject)});
          }
        });
      }
    });
  }

  getMAClients(data) {
    var maClients = {
      labels: data.labels,
      series: [data.values]
    };
    return maClients;
  }

  getMADatapoints(data) {
    var maDatapoints = {
      labels: data.labels,
      series: [data.values]
    };
    return maDatapoints;
  }

  getUsageData(project) {
    var selectedProject = project || this.state.selectedProject;
    Log.debug(selectedProject);
    if (selectedProject.plan) {
      const used = selectedProject.plan.used;
      const total = selectedProject.plan.datapoints;
      const remaining = total - used;
      const pie = {
        labels: [ (Math.round((100 - (used/total)*100)*100)/100).toString() + "%", (Math.round(((used/total)*100)*100)/100).toString() + "%"],
        series: [ remaining, used]
      };
      Log.debug(pie);
      return pie;
    } else {
      return {
        labels: [],
        series: []
      };
    }
  }
    render(){
        return (
            <div className="main-content">
                <NotificationSystem ref="notificationSystem" style={style}/>
                <Grid fluid>
                    <Row>
                      <Col md={4}>
                          <Card
                              title="Datapoint usage"
                              content={
                                  <ChartistGraph data={this.state.usageData} options={this.state.tooltipOptionsSimple} type="Pie"/>
                              }
                              legend={
                                  <div>
                                      <i className="fa fa-circle text-info"></i> Remaining
                                      <i className="fa fa-circle text-danger"></i> Used
                                  </div>
                              }
                              stats={
                                  <div>
                                      <i className="fa fa-clock-o"></i> <TimeAgo date={this.state.usageTimestamp} />
                                  </div>
                              }
                          />
                      </Col>
                      <Col md={8}>
                          <Card
                              title="Daily Active Clients"
                              content={
                                  <ChartistGraph
                                      data={this.state.maClients}
                                      options={this.state.tooltipOptions}
                                      type="Bar"/>
                                  }
                                  legend={
                                      <div>
                                        <br/>
                                      </div>
                                  }
                                  stats={
                                      <div>
                                          <i className="fa fa-history"></i> <TimeAgo date={this.state.maClientsTimestamp} />
                                      </div>
                                  }
                              />
                          </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                          <Card
                              title="Daily Datapoint Volume"
                              content={
                                  <ChartistGraph
                                      data={this.state.maDatapoints}
                                      options={this.state.tooltipOptions}
                                      type="Bar"/>
                                  }
                                  legend={
                                      <div>
                                        <br/>
                                      </div>
                                  }
                                  stats={
                                      <div>
                                          <i className="fa fa-history"></i> <TimeAgo date={this.state.maDatapointsTimestamp} />
                                      </div>
                                  }
                              />
                          </Col>
                      </Row>
                </Grid>
            </div>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx